import React from 'react';
import './index.css';
import clsx from 'classnames';
import { More } from 'components';

const Service = () => {
  const serviceList = [
    {
      img: '/img/serviceOne.png',
      title: '场地规划和设计',
    },
    {
      img: '/img/serviceTwo.png',
      title: '管理软件开发',
    },
    {
      img: '/img/serviceThree.png',
      title: '设备及附件配置',
    },
    {
      img: '/img/serviceFour.png',
      title: '库房建设',
    },
    {
      img: '/img/serviceFive.png',
      title: '体系建设',
    },
    {
      img: '/img/serviceSix.png',
      title: '技术培训',
    },
  ];

  return (
    <div className={clsx('service')}>
      <div className={clsx('service-title')}>服务内容</div>
      <div className={clsx('service-list')}>
        {serviceList?.map((v, index) => {
          return (
            <div
              className={clsx('service-item')}
              key={index}
              style={{ backgroundImage: `url(${v.img})` }}
            >
              <div className={clsx('service-item__title')}>{v.title}</div>
            </div>
          );
        })}
      </div>
      {/* 更多按钮 */}
      <More path='/servicesContent' style={{ margin: '9px 0 24px' }} />
    </div>
  );
};

export default Service;
